import styled from "@emotion/styled";
import { Stack } from "@mui/material";



export const StyledStack = styled(Stack)({
  padding: "12px",
  "> span": {
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
  },
  "img, svg": {
    fontSize: "16px",
    marginRight: "7px",
  }
});